import { BaseXHR } from 'utils/axios';

export const getSearchComboApi = data =>
  BaseXHR.$post('b2b/holiday/search/combo', data);
export const getSearchFlightApi = data =>
  BaseXHR.$post('b2b/holiday/search/flights', data);
export const getCommonMasterDataApi = data =>
  BaseXHR.$get('b2b/holiday/common/master-data', data);
export const getCommonCountryDataApi = data =>
  BaseXHR.$get('b2b/holiday/common/country', data);
export const getCommonAirportDataApi = data =>
  BaseXHR.$get('b2b/holiday/common/airport', data);
export const getCommonAmenitiesDataApi = data =>
  BaseXHR.$get('b2b/holiday/common/amenities', data);
export const getCommonFlightSegmentDataApi = data =>
  BaseXHR.$post('b2b/holiday/common/flight-segment/search', data);
export const getCommonHotelDataApi = data =>
  BaseXHR.$post('b2b/holiday/search/combo/hotels', data);
export const getCancelPolicyDataApi = data =>
  BaseXHR.$get('b2b/holiday/order/cancellation-policies', data);
export const getHotelDetailDataApi = data =>
  BaseXHR.$get('b2b/holiday/order/hotel/detail/' + data.hotelId, data);
export const getCreateOrderHolidayApi = data =>
  BaseXHR.$post('b2b/holiday/order/create', data);
export const getInfoOrderHolidayApi = data =>
  BaseXHR.$get('b2b/holiday/order/detail/' + data.orderCode);
export const getFlightDetailApi = data =>
  BaseXHR.$get('b2b/holiday/order/detailflight/' + data.bookingId);
export const getConfirmPriceApi = data =>
  BaseXHR.$post('b2b/holiday/order/confirm-price', data);

// Approve / reject (checkout) for holiday orders
export const postApprovePaymentApi = data =>
  BaseXHR.$post('b2b/v1/checkout/approve-payment', data);

export const CONFIRMED_STATUS = 'confirmed';
export const UNCONFIRMED_STATUS = 'unconfirmed';

export const postCancelOrderHolidayApi = data =>
  BaseXHR.$post('b2b/holiday/order/cancel', data);
export const getHolidayOrderListingApi = params =>
  BaseXHR.$get('b2b/holiday/order/listing', params);
